import {useAccessToken} from "../../services/auth"
import React, {useState} from "react"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import Loading from "../../components/Loading/Loading"
import {CheckDeposit, getCheckDepositRequest, updateCheckDeposit} from "../../resources/checkDeposits"
type CloseFunc = () => void
type RefreshFunc = () => void

export function UpdateCheckDepositModalContent({
	close,
	refreshFunc,
	checkDeposit,
}: {
	close: CloseFunc
	refreshFunc: RefreshFunc
	checkDeposit: CheckDeposit
}) {
	const accessToken = useAccessToken()
	const [state, update] = useAsyncResultIdle(updateCheckDeposit)
	const [amount, setAmount] = useState(`${checkDeposit.attributes.amount}`)
	const [counterpartyRoutingNumber, setCounterpartyRoutingNumber] = useState(
		checkDeposit.attributes.counterparty.routingNumber
	)
	const [counterpartyAccountNumber, setCounterpartyAccountNumber] = useState(
		checkDeposit.attributes.counterparty.accountNumber
	)

	return (
		<AsyncResultModal
			title="Edit Details For X9"
			secondaryTitle="Available Fields To Override:"
			onSubmit={() =>
				update({
					accessToken,
					id: checkDeposit.id,
					amount: parseInt(amount),
					counterpartyRoutingNumber,
					counterpartyAccountNumber,
				})
			}
			close={close}
			state={state}
			buttonClassname="is-success"
			buttonText="Update"
			successText="Updated"
			errorToText={(err) => (err.errors[0].detail ? err.errors[0].detail : err.errors[0].title)}
			onSuccess={refreshFunc}
		>
			<div className="field">
				<label className="label">Check Amount</label>
				<div className="control">
					<input
						className="input"
						type="text"
						placeholder="Check Amount"
						value={amount}
						pattern="^[0-9]*$"
						required
						onChange={(e) => setAmount(e.target.value)}
					/>
				</div>
			</div>
			<div className="flex-container justify-content-sb">
				<div className="field" style={{width: "45%"}}>
					<label className="label">Counterpart Routing #</label>
					<div className="control">
						<input
							className="input"
							type="text"
							placeholder="Counterpart Routing #"
							value={counterpartyRoutingNumber}
							pattern="^\d{9}$"
							required
							onChange={(e) => setCounterpartyRoutingNumber(e.target.value)}
						/>
					</div>
				</div>
				<div className="field" style={{width: "45%"}}>
					<label className="label">Counterpart Account #</label>
					<div className="control">
						<input
							className="input"
							type="text"
							placeholder="Counterpart Account #"
							value={counterpartyAccountNumber}
							pattern="^[0-9]*$"
							required
							onChange={(e) => setCounterpartyAccountNumber(e.target.value)}
						/>
					</div>
				</div>
			</div>
		</AsyncResultModal>
	)
}

export default function UpdateCheckDepositModal({
	checkDepositId,
	refreshFunc,
	refreshToken,
	close,
}: {
	checkDepositId: string
	close: CloseFunc
	refreshToken: number
	refreshFunc: RefreshFunc
}) {
	const accessToken = useAccessToken()

	const checkDepositAsync = useAsyncResult(
		() => getCheckDepositRequest({accessToken, id: checkDepositId}),
		[refreshToken]
	)

	return checkDepositAsync.match(
		() => <Loading />,
		(checkDeposit) => (
			<UpdateCheckDepositModalContent checkDeposit={checkDeposit.data} close={close} refreshFunc={refreshFunc} />
		),
		(_) => null
	)
}
